import { Accordion } from "react-bootstrap";
import { useMemo } from "react";
import PreviewSettings from "./customization/PreviewSettings";

const Customization = ({
    backgrounds,
    selectedBackground,
    appliedBackground,
    frames,
    selectedFrames,
    appliedFrame,
    stickers,
    selectedStickers,
    appliedStickers,
    handleChange,
    uploadImage,
    selectChange,
    handlePopUp
}) => {

    const sections = useMemo(() => {
        return [
        {
            title: "Set the Scene",
            props: {
                isCheckedListState: "selectedBackground",
                applyPreviewState: "appliedBackground",
                mediaType: "backgrounds",
                list: backgrounds,
                isCheckedList: selectedBackground,
                applyPreview: appliedBackground
            }
        },
        {
            title: "Frame It Up!",
            props: {
                isCheckedListState: "selectedFrames",
                applyPreviewState: "appliedFrame",
                mediaType: "frames",
                list: frames,
                isCheckedList: selectedFrames,
                applyPreview: appliedFrame
            }
        },
        {
            title: "Add Fun Stickers",
            props: {
                isCheckedListState: "selectedStickers",
                applyPreviewState: "appliedSticker",
                mediaType: "stickers",
                list: stickers,
                isCheckedList: selectedStickers,
                applyPreview: appliedStickers
            }
        }
    ]
    }, [backgrounds, selectedBackground, appliedBackground, frames, selectedFrames, appliedFrame, stickers, selectedStickers, appliedStickers]);

    return (
        <div className="pb-scroll pe-3">
            <div className="ra-tab form-group mb-3">
                <label className="font-weight-bolder">Main Settings</label>
                <Accordion defaultActiveKey="Set the Scene">
                    {sections.map(({ title, props: sectionProps }) => (
                        <Accordion.Item eventKey={title} key={title}>
                            <Accordion.Header>{title}</Accordion.Header>
                            <Accordion.Body className="px-0">
                                <PreviewSettings {...sectionProps} handleChange={handleChange} uploadImage={uploadImage} selectChange={selectChange} handlePopUp={handlePopUp} />
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </div>
    );
};

export default Customization;